import { SearchFilledIcon } from '@backend/lib-design-system/icons';

import { useSearchFormContext } from '~/contexts/SearchFormContext/SearchFormContext';
import { useIsPromanBusinessUnit, useTranslation } from '~/hooks';

import { Button } from './SearchButton.styles';

type SearchButtonProps = { className?: string };

export const SearchButton = ({ className }: SearchButtonProps) => {
  const t = useTranslation();
  const { submit } = useSearchFormContext();
  const isProman = useIsPromanBusinessUnit();

  const handleSearchButtonClick = async () => {
    await submit();
  };

  return (
    <Button
      size="m"
      onClick={handleSearchButtonClick}
      className={className}
      $isProman={isProman}
      aria-label={t('search_button.label')}
    >
      <SearchFilledIcon size="xl" />
    </Button>
  );
};
